<template>
  <el-popover :width="width" :title="title" :placement="placement" :trigger="trigger" v-bind="$attrs" v-on="$listeners">
    <template v-if="$slots.default">
      <slot></slot>
    </template>
    <template v-else>
      <img class="qm-example__img" :src="url" alt="示例图片" draggable="false" />
    </template>

    <template v-if="$slots.reference">
      <slot slot="reference" name="reference"></slot>
    </template>
    <template v-else>
      <a slot="reference" class="qm-example__reference">查看示例</a>
    </template>
  </el-popover>
</template>

<script>
export default {
  name: 'QmExample',
  props: {
    width: {
      type: Number,
      default: 375 + 12 * 2,
    },
    title: {
      type: String,
      default: '示例图片',
    },
    placement: {
      type: String,
      default: 'right',
    },
    trigger: {
      type: String,
      default: 'hover',
    },
    url: {
      type: String,
    },
    preload: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    // 进行预加载
    if (this.preload && this.url) {
      const img = document.createElement('img')
      img.src = this.url
    }
  },
}
</script>
